<template>
  <div>
    <el-dialog :width="Diawidth" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
      :close-on-click-modal="true" :show-close="true" :close-on-press-escape="true" :title="DialogData.ydbXjjhMc+'（'+DialogData.ydbXjrq+'）'">
      <!-- <div class="Diatitles">淤地坝详情</div> -->
      <div class="contents">
        <p>巡查人：<span style="color: darkorange;">{{DialogData.ydbFxxczrr}}</span></p>
        <p>联系方式：<span style="color: darkorange;">{{DialogData.ydbFxxczrrLxfs}}</span></p>
        <!-- <p>巡查名称：<span style="color: darkorange;">{{DialogData.ydbXjjhMc}}</span></p> -->
        <!-- <p>巡查日期：<span style="color: darkorange;">{{DialogData.ydbXjrq}}</span></p> -->
        <!-- <p>坝体裂缝：<span style="color: darkorange;">{{DialogData.ydbBtlf}}</span></p>
        <p>坝体滑坡坍塌：<span style="color: darkorange;">{{DialogData.ydbBthptt}}</span></p>
        <p>坝体坡率问题：<span style="color: darkorange;">{{DialogData.ydbBtplwt}}</span></p>
        <p>坝体冲缺冲沟：<span style="color: darkorange;">{{DialogData.ydbBtcqcg}}</span></p>
        <p>坝体管涌渗漏：<span style="color: darkorange;">{{DialogData.ydbBtgysl}}</span></p>
        <p>放水建筑物卧管竖井：<span style="color: darkorange;">{{DialogData.ydbFsjzwwgsj}}</span></p>
        <p>放水建筑物涵洞涵管：<span style="color: darkorange;">{{DialogData.ydbFsjzwhdhg}}</span></p>
        <p>放水建筑物明渠：<span style="color: darkorange;">{{DialogData.ydbFsjzwmq}}</span></p>
        <p>泄水建筑物损毁：<span style="color: darkorange;">{{DialogData.ydbXsjzwsh}}</span></p>
        <p>泄水建筑物淘刷悬空：<span style="color: darkorange;">{{DialogData.ydbXsjzwtsxk}}</span></p>
        <p>泄水建筑物其他：<span style="color: darkorange;">{{DialogData.ydbXsjzwqt}}</span></p>
        <p>道路不通：<span style="color: darkorange;">{{DialogData.ydbDlbt}}</span></p>
        <p>两岸边坡不稳定：<span style="color: darkorange;">{{DialogData.ydbLabpbwd}}</span></p>
        <p>其他：<span style="color: darkorange;">{{DialogData.ydbQt}}</span></p> -->
      </div>
      <el-table :data="tableData" border style="width: 100%;" height="595" :span-method="SpanMethod">
        <el-table-column prop="firstName" label="" width="160"></el-table-column>
        <el-table-column prop="SecondName" label="检查项目" width="165"></el-table-column>
        <el-table-column prop="result" label="检查结果" width="400"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
  // import {
  //   xcInfo,
  // } from "@/api/api.js";
  export default {
    props: ["DialogData"],
    data() {
      return {
        dialogVisible: true,
        Diawidth: "40%",

        tableData: [],
      }
    },
    mounted() {
      this.tableData = [{
        firstName: '坝体',
        SecondName: '裂缝',
        result: this.DialogData.ydbBtlf
      }, {
        firstName: '坝体',
        SecondName: '滑坡坍塌',
        result: this.DialogData.ydbBthptt
      }, {
        firstName: '坝体',
        SecondName: '坡率问题',
        result: this.DialogData.ydbBtplwt
      }, {
        firstName: '坝体',
        SecondName: '冲缺冲沟',
        result: this.DialogData.ydbBtcqcg
      }, {
        firstName: '坝体',
        SecondName: '管涌渗漏',
        result: this.DialogData.ydbBtgysl
      }, {
        firstName: '放水建筑物',
        SecondName: '卧管竖井',
        result: this.DialogData.ydbFsjzwwgsj
      }, {
        firstName: '放水建筑物',
        SecondName: '涵洞涵管',
        result: this.DialogData.ydbFsjzwhdhg
      }, {
        firstName: '放水建筑物',
        SecondName: '明渠',
        result: this.DialogData.ydbFsjzwmq
      }, {
        firstName: '泄水建筑物',
        SecondName: '损毁',
        result: this.DialogData.ydbXsjzwsh
      }, {
        firstName: '泄水建筑物',
        SecondName: '淘刷悬空',
        result: this.DialogData.ydbXsjzwtsxk
      }, {
        firstName: '泄水建筑物',
        SecondName: '其他',
        result: this.DialogData.ydbXsjzwqt
      }, {
        firstName: '其他安全隐患',
        SecondName: '道路不通',
        result: this.DialogData.ydbDlbt
      }, {
        firstName: '其他安全隐患',
        SecondName: '两岸边坡不稳定',
        result: this.DialogData.ydbLabpbwd
      }, {
        firstName: '其他安全隐患',
        SecondName: '重要设施',
        result: this.DialogData.ydbZyss
      }, {
        firstName: '其他安全隐患',
        SecondName: '监控设备',
        result: this.DialogData.ydbJksb
      }, {
        firstName: '备注',
        SecondName: '',
        result: this.DialogData.ydbQt
      }];
    },
    methods: {
      SpanMethod({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        // 合并行列产品名字相同合并（计算组长度以内的列，需要进行合并操作的列）
        let mergeLength = 2; //需要进行横纵合并的列
        if (columnIndex < mergeLength) {
          let finArray = [1, 1];
          // 处理行数据
          let cgname = Object.keys(row)[columnIndex]
          if (rowIndex === 0 || row[cgname] !== this.tableData[rowIndex - 1][cgname]) {
            let rowspan = 1;
            //计算需要进行合并操作的行
            for (let i = 0; i < this.tableData.length - 1; i++) {
              // 只合并连续的
              if (this.tableData[i][cgname] === row[cgname] && this.tableData[i + 1][cgname] === row[cgname]) {
                rowspan++;
              }
            }
            finArray[0] = rowspan;
          } else {
            finArray[0] = 0;
          }

          // 处理列数据
          let colkeys = Object.keys(row);
          let cgvalue = Object.values(row)[columnIndex]
          if (columnIndex === 0 || row[colkeys[columnIndex - 1]] !== row[colkeys[columnIndex]]) {
            let colspan = 1;
            //计算需要进行合并操作的列
            for (let i = columnIndex; i < mergeLength; i++) {
              // 只合并连续的
              if (row[colkeys[i]] === cgvalue && row[colkeys[i + 1]] === cgvalue && i + 1 < mergeLength) {
                colspan++;
              }
            }
            finArray[1] = colspan;
          } else {
            finArray[1] = 0;
          }
          return finArray
        }
      },

      handleClose(done) {
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },

      cancel() { //取消
        this.dialogVisible = false;
        this.$emit("cancel", {
          "dialogVisible": this.dialogVisible
        })
      },
    }
  }
</script>

<style scoped>
  >>>.el-dialog {
    height: 700px;
    background: url(../../common/images/dialog.png) no-repeat center;
    background-size: 100% 100%;
  }

  >>>.el-dialog__body {
    height: 710px;
    padding-top: 0;
  }

  >>>.el-dialog__header {
    /* border: none; */
    padding-left: 0;
    margin: 10px 20px 8px 20px;
  }
  
  >>>.el-dialog__body, .el-dialog__footer{
      background: transparent;
  }

  .contents {
    width: 100%;
    height: 40px;
    margin: 0;
  }

  .contents p {
    float: left;
    width: 48%;
    height: 40px;
    line-height: 40px;
    margin-left: 10px;
    font-size: 16px;
    color: #FFF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  >>>.el-table {
    /* margin-top: 10px; */
    /* border-color: #0077AA; */
    border: 1px solid #0077AA;
    background-color: transparent !important;
  }

  >>>.el-table thead {
    background-color: rgba(0, 179, 254, 0.5) !important;
  }

  >>>.el-table .cell {
    text-align: center;
    font-size: 16px;
    color: #eaeaea;
  }

  >>>.el-table th {
    background-color: transparent !important;
    border-color: #0077AA;
  }

  >>>.el-table tr {
    background-color: transparent !important;
  }

  >>>.el-table td,
  >>>.el-table th.is-leaf {
    border-color: #0077AA;
  }

  >>>.el-table__body tr:hover>td {
    background-color: transparent !important;
  }

  >>>.el-table td, .el-table th {
    padding: 5px 0 !important;
  }

  >>>.el-table--border::after,
  >>>.el-table--group::after,
  >>>.el-table::before {
    background-color: #0077AA;
  }
</style>
